import type { ReactNode } from 'react';
import { useState } from 'react';

import type { DialogProps } from '@packages/shared/src/ui/Dialog/Dialog';

import { LoginDialog } from '../LoginDialog.client';

export interface LoginDialogComposedProps
  extends Omit<DialogProps, 'children' | 'isOpen' | 'onClose'> {
  /** Render prop function, so children can control LoginDialog */
  children: (showDialog: () => void, closeDialog: () => void) => ReactNode;
}

/** Composed component to include and control LoginDialog */
export const LoginDialogComposed = ({ children, ...dialogProps }: LoginDialogComposedProps) => {
  const [showLoginDialog, setShowLoginDialog] = useState(false);

  const openLoginDialog = () => setShowLoginDialog(true);
  const closeLoginDialog = () => {
    setShowLoginDialog(false);
  };

  return (
    <>
      <LoginDialog isOpen={showLoginDialog} {...dialogProps} onClose={closeLoginDialog} />
      {children(openLoginDialog, closeLoginDialog)}
    </>
  );
};
